/**
 * Copyright (c) Qwoach LLC 2021. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 11.02.21
 *
 */
import Cookies from 'js-cookie'
import AnalyticsManager from './analytics'
let analyticsManager = new AnalyticsManager()

function onExistPopupShown(){
    let _ = analyticsManager.trackEvent("Exist popup shown", {category: "exit_popup_want_more_clients", ...analyticsProps()})
}

function onAffiliateFormValidated(isValid, name){
    if(!isValid){
        let _ = analyticsManager.trackEvent("Form validation error", {category: "form", label: name, isValid: isValid, ...analyticsProps()})
    }
}

function onAffiliateFormSubmittedSuccess(){
    let _ = analyticsManager.trackEvent("Form submitted successfully", {category: "form", ...analyticsProps()})
}

function onAffiliateFormSubmittedError(reason){
    let _ = analyticsManager.trackEvent("Form submit error", {category: "form", message: reason, ...analyticsProps()})
}

window.onExistPopupShown = onExistPopupShown
window.onAffiliateFormValidated = onAffiliateFormValidated
window.onAffiliateFormSubmittedSuccess = onAffiliateFormSubmittedSuccess
window.onAffiliateFormSubmittedError = onAffiliateFormSubmittedError
window.analyticsManager = analyticsManager

$(function() {
    let url = new URL(window.location.href)
    // console.log("get started: ", url)

    if(window.disableTracking){
        return
    }

    // console.log("get started2")

    analyticsManager.trackPageView()

    // console.log("get started3")

    analyticsManager.trackUrlParams()
    analyticsManager.setUserProps({first_contact: 'website'})
    analyticsManager.setUserPropsOnce({initial_first_contact: 'website'})
    analyticsManager.setCohortVisitParams()
    // console.log("get started4")


    let trackFnInternal = (elem, name, category) => {
        trackClickElement(elem, name, {category: category, text: elem.innerText, link: elem.href, elementId: elem.id, ...analyticsProps()})
    }

    let aTags = document.getElementsByTagName("a")
    let buttons = document.getElementsByTagName("button")

    for(let elem of aTags){
        trackFnInternal(elem, "Website Link clicked", "link")
    }
    for(let elem of buttons){
        trackFnInternal(elem, "Website Button clicked", "button")
    }





    // trackClick("verified_by_capterra", "Review: verified by capterra clicked", {category: "review", ...analyticsProps()})
    //
    // trackClick("requestDemo1", "Request free demo clicked", {category: "above_the_fold", ...analyticsProps()})
    // trackClick("requestDemo2", "Request free demo clicked", {category: "request_demo_btn_2", ...analyticsProps()})
    // trackClick("requestDemo3", "Request free demo clicked", {category: "request_demo_btn_3", ...analyticsProps()})
    // trackClick("requestDemo4", "Request free demo clicked", {category: "request_demo_btn_4", ...analyticsProps()})
    // trackClick("requestDemoMultipleCoaches", "Request free demo clicked", {category: "request_demo_multiple_coaches", ...analyticsProps()})
    // trackClick("requestAccess1", "Request Access Unlim", {category: "access_request", ...analyticsProps()})
    // trackClick("requestAccess2", "Request Access Essentials", {category: "access_request", ...analyticsProps()})
    // trackClick("applyCoreContributor", "Core Contributor Apply Clicked", {category: "access_request", ...analyticsProps()})
    //
    //
    // trackClick("requestAccess1", "Request access clicked", {category: "requestAccess1", ...analyticsProps()})
    // trackClick("requestAccess2", "Request access clicked", {category: "requestAccess2", ...analyticsProps()})
    // trackClick("requestAccess3", "Request access clicked", {category: "requestAccess3", ...analyticsProps()})
    // trackClick("requestAccess4", "Request access clicked", {category: "requestAccess4", ...analyticsProps()})
    // trackClick("requestAccess5", "Request access clicked", {category: "requestAccess5", ...analyticsProps()})
    // trackClick("buyNow1", "Buy now clicked", {category: "buyNow1", label: "Buy Scheduler", ...analyticsProps()})
    //
    // trackClick("adhdRequestAccess1", "ADHD Request access clicked", {category: "requestAccess1", ...analyticsProps()})
    // trackClick("adhdRequestAccess2", "ADHD Request access clicked", {category: "requestAccess2", ...analyticsProps()})
    // trackClick("adhdRequestAccess3", "ADHD Request access clicked", {category: "requestAccess3", ...analyticsProps()})
    // trackClick("adhdRequestAccess4", "ADHD Request access clicked", {category: "requestAccess4", ...analyticsProps()})
    //
    // trackClick("navbar_home", "Navbar home clicked", {category: "nav_bar", ...analyticsProps()})
    // trackClick("navbar_features", "Navbar features clicked", {category: "nav_bar", ...analyticsProps()})
    // trackClick("navbar_why", "Navbar 'why join?' clicked", {category: "nav_bar", ...analyticsProps()})
    // trackClick("navbar_pricing", "Navbar pricing clicked", {category: "nav_bar", ...analyticsProps()})
    // trackClick("navbar_affiliation", "Navbar affiliation clicked", {category: "nav_bar", ...analyticsProps()})
    // trackClick("navbar_whitelabeling", "Navbar Custom Branding clicked", {category: "nav_bar", ...analyticsProps()})
    // trackClick("navbar_hipaa", "Navbar HIPAA clicked", {category: "nav_bar", ...analyticsProps()})
    //
    // trackClick("navbar_genogram", "Navbar genogram clicked", {category: "nav_bar", ...analyticsProps()})
    // trackClick("navbar_timeline", "Navbar trauma timeline clicked", {category: "nav_bar", ...analyticsProps()})
    // trackClick("navbar_wheel", "Navbar wheel of life clicked", {category: "nav_bar", ...analyticsProps()})
    //
    // trackClick("navbar_signup", "Sign up clicked", {category: "nav_bar", ...analyticsProps()})
    // trackClick("signup1", "Sign up clicked", {category: "sign_up_btn_1", ...analyticsProps()})
    // trackClick("signup1_1", "Sign up clicked", {category: "sign_up_btn_1_1", ...analyticsProps()})
    // trackClick("signup1_2", "Sign up clicked", {category: "sign_up_btn_1_2", ...analyticsProps()})
    // trackClick("signup1_3", "Sign up clicked", {category: "sign_up_btn_1_3", ...analyticsProps()})
    // trackClick("signup1_4", "Sign up clicked", {category: "sign_up_btn_1_4", ...analyticsProps()})
    // trackClick("signup2", "Sign up clicked", {category: "sign_up_btn_2", ...analyticsProps()})
    // trackClick("signup3", "Sign up clicked", {category: "sign_up_btn_3", ...analyticsProps()})
    // trackClick("signup-plan", "Sign up clicked", {category: "sign_up_btn_plan", ...analyticsProps()})
    //
    // trackClick("requestScheduler1", "Request scheduler access", {category: "requestScheduler1", ...analyticsProps()})
    // trackClick("requestScheduler2", "Request scheduler access", {category: "requestScheduler2", ...analyticsProps()})
    // trackClick("requestScheduler3", "Request scheduler access", {category: "requestScheduler3", ...analyticsProps()})
    //
    // onClickFn(["requestScheduler1", "requestScheduler2", "requestScheduler3"], () => {
    //     fbq('trackCustom', 'Lead - Free scheduler');
    // })
    //
    // trackClick("affiliate_interested_1", "Interested in affiliation clicked", {category: "affiliation", label: "affiliate_interested_btn_1", ...analyticsProps()})
    // trackClick("affiliate_interested_2", "Interested in affiliation clicked", {category: "affiliation", label: "affiliate_interested_btn_2", ...analyticsProps()})
    //
    // trackClick("applyAffiliation", "Apply for the affiliation clicked", {category: "affiliation", ...analyticsProps()})
    // trackClick("close_affiliate_popup", "Affiliation popup close clicked", {category: "affiliation", ...analyticsProps()})
    //
    // trackClick("submitRequestAccess", "Request access submit clicked", {category: "request_access", ...analyticsProps()})
    // trackClick("close_requestAccess_popup", "Request access popup close clicked", {category: "request_access", ...analyticsProps()})
    //


    // trackClick("moreClients", "Want more clients 'learn more' clicked", {category: "exit_popup_want_more_clients", ...analyticsProps()})
    // trackClick("exitPopupClose", "Exit popup close clicked", {category: "exit_popup_want_more_clients", ...analyticsProps()})


    // trackClick("join-waitlist-1", "Join waitlist button 1 clicked", analyticsProps())
    // trackClick("join-waitlist-2", "Join waitlist button 2 clicked", analyticsProps())
    // trackClick("join-waitlist-3", "Join waitlist button 3 clicked", analyticsProps())
    //
    // trackClick("waitlist_close", "Cancel waitlist dialog clicked", analyticsProps())
    // trackClick("waitlist_submit", "Submit email to waitlist clicked", analyticsProps())

    url.searchParams.forEach((value, key) => {
        let initialKey = "initial_" + key
        if(!Cookies.get(initialKey)){
            Cookies.set(initialKey, value, {expires: 30})
        }
        Cookies.set(key, value, {expires: 30})
    })


})
function analyticsProps(){
    return {
        title: document.title
    }
}

function trackClick(elemIds, eventName, props, transformPropsCallback){
    if(!Array.isArray(elemIds)){
        elemIds = [elemIds]
    }
    if(typeof props === "function"){
        transformPropsCallback = props
        props = {}
    }
    elemIds.forEach(elemId => {
        let elem = document.getElementById(elemId)
        if(elem){
            trackClickElement(elem, eventName, props, transformPropsCallback)
        }
    })



}

function trackClickElement(elem, eventName, props, transformPropsCallback){
    let propsLocal = {}
    Object.assign(propsLocal, props || {})

    if(transformPropsCallback){
        propsLocal = transformPropsCallback(elem, propsLocal) || propsLocal
    }
    elem.addEventListener("click", () => {
        let _ = analyticsManager.trackEvent(eventName, propsLocal)
    })
}

function onClickFn(elemIds, callback){
    if(!Array.isArray(elemIds)){
        elemIds = [elemIds]
    }
    elemIds.forEach(elemId => {
        let elem = document.getElementById(elemId)
        if(elem){
            elem.addEventListener("click", (event) => {
                callback(event, elem)
            })
        }
    })
}
